import { DataGrid, NavigationItem } from '../../../ui-toolkit/components';
import { IBootstrapTableColumnProps, IDataRow } from 'react-bootstrap-table-next';
import { IUnderwriterProfileSummaryData } from '../../../types/administration/pricing/IUnderWriterProfileSummary';
import React from 'react';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { underwriterProfileURLGenerator } from 'utilities/administration/underwriterProfileURLGenerator';
import { StateAbbreviationToLongName } from '../../../ui-toolkit/enums/states';

interface IUnderwriterProfileTableProps {
  data: IUnderwriterProfileSummaryData[];
  fetchStatus: IFetchStatus;
}
// Note: the design calls for State and Name, but some states, like CO, have multiple zones.
// In the future, there may be underwriters with different effective dates. That column in included.
// In the future, this table may be paginated.

export const UnderwriterProfileTable: React.FC<IUnderwriterProfileTableProps> = ({ data, fetchStatus }) => (
  <DataGrid keyField={'id'} data={data} columns={underwriterColumns} loading={fetchStatus.fetching} />
);

const underwriterColumns: IBootstrapTableColumnProps<IUnderwriterProfileSummaryData>[] = [
  {
    dataField: 'state',
    headerStyle: { width: '50px' },
    sort: true,
    text: 'State',
    formatter: (column, row?: IDataRow<IUnderwriterProfileSummaryData>) => (
      <NavigationItem
        text={!!column ? StateAbbreviationToLongName[column as string] : ''}
        to={!!row ? `/spa/admin/administration/underwriters/${underwriterProfileURLGenerator(row)}` : ''}
        isInline
        isPrimary
        inheritParentColors
      />
    ),
  },
  {
    dataField: 'zone',
    headerStyle: { width: '50px' },
    sort: true,
    text: 'Zone',
    formatter: (column, row?: IDataRow<IUnderwriterProfileSummaryData>) => (
      <NavigationItem
        text={(column as string) || '—'}
        to={!!row ? `/spa/admin/administration/underwriters/${underwriterProfileURLGenerator(row)}` : ''}
        isInline
        inheritParentColors
      />
    ),
  },
  {
    dataField: 'underwriter',
    headerStyle: { width: '150px' },
    sort: true,
    text: 'Underwriter Name',
    formatter: (column, row?: IDataRow<IUnderwriterProfileSummaryData>) => (
      <NavigationItem
        text={(column as string) || '—'}
        to={!!row ? `/spa/admin/administration/underwriters/${underwriterProfileURLGenerator(row)}` : ''}
        isInline
        inheritParentColors
      />
    ),
  },
  {
    dataField: 'effectiveDate',
    headerStyle: { width: '150px' },
    sort: true,
    text: 'Effective Date',
    formatter: (column, row?: IDataRow<IUnderwriterProfileSummaryData>) => (
      <NavigationItem
        text={(column as string) || '—'}
        to={!!row ? `/spa/admin/administration/underwriters/${underwriterProfileURLGenerator(row)}` : ''}
        isInline
        inheritParentColors
      />
    ),
  },
];
